import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "~/contexts/AuthProvider";
import { routes } from "~/router";

interface GuestOnlyRouteProps {
  children: React.ReactNode;
}

const GuestOnlyRoute: React.FC<GuestOnlyRouteProps> = ({ children }) => {
  const location = useLocation();
  const { token } = useAuth();

  // redirect if user has auth token
  if (token) {
    const capturedFrom = location.state?.from;
    // Preserve the full original target (search/hash), matching the MFA flow
    // in AppGate so deep links with query params survive the auth round-trip.
    const from = capturedFrom
      ? `${capturedFrom.pathname}${capturedFrom.search ?? ""}${capturedFrom.hash ?? ""}`
      : routes.home();

    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
};

export default GuestOnlyRoute;
